import styles from "./MarketLink.module.css";
import Button from "../../../UI/Button";
import dottedArrow from "../../../../assets/doted-arrow.png";
import { useContext } from "react";
import DataContext from "../../../store/data-context";
import { useNavigate } from "react-router";
export default function MarketLink() {
  const dataCtx = useContext(DataContext);
  const navigate = useNavigate();

  const navigateToMarket = (e) => {
    navigate(`/${dataCtx.lang.lang}/${dataCtx.lang.market}`);
  };

  return (
    <main className={styles.main}>
      <div
        className={styles.text}
        dangerouslySetInnerHTML={{
          __html: dataCtx.pageData.market.to,
        }}
      ></div>
      <div className={styles.actions}>
        <img src={dottedArrow} alt="Arrow." className={styles.arrow} />
        <div className={styles.button}>
          <Button onClick={navigateToMarket} inverted="true">
            {dataCtx.pageData.market.to_button}
          </Button>
        </div>
      </div>
    </main>
  );
}
